import { SourceKind } from 'types/schema-generated-types';

export enum EndOfYearProcessingNotificationType {
  UPCOMING = 'UPCOMING',
  PROCESSING_COMPLETE = 'PROCESSING_COMPLETE',
  BEFORE_NEXT_IMPLEMENTATION = 'BEFORE_NEXT_IMPLEMENTATION',
  PROCESSING_FAILED = 'PROCESSING_FAILED',
  NEW_YEAR_IMPLEMENTED = 'NEW_YEAR_IMPLEMENTED'
}

export enum ProcessingStatus {
  QUEUED = 'queued',
  STARTED = 'started',
  COMPLETE = 'complete',
  ERROR = 'error',
  COMPLETE_WITH_ERRORS = 'complete-with-errors'
}

export type UseEndOfYearProcessing = {
  notificationType?: EndOfYearProcessingNotificationType;
  values: EndOfYearProcessingFormValues;
  openModal: () => void;
  handleUpdate: (values: EndOfYearProcessingFormValues) => void;
};

export type EndOfYearProcessingFormValues = {
  id?: number;
  dateTermEnd?: Date;
  upcomingDateTermStart?: Date;
  upcomingDateTermEnd?: Date;
  upcomingIntegrationType?: SourceKind;
};

export const integrationTypes = [
  {
    value: SourceKind.ONE_ROSTER,
    label: 'One time bulk upload'
  },
  {
    value: SourceKind.CLEVER,
    label: 'Clever'
  },
  {
    value: SourceKind.CLASS_LINK,
    label: 'ClassLink'
  },
  {
    value: SourceKind.GOOGLE,
    label: 'Google SSO'
  }
];
